import { heroStats } from "@/mocks/site";

export default function Hero() {
  return (
    <section id="top" className="relative w-full min-h-[560px] h-[88vh] md:h-[680px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20background%20evoking%20Korean%20cinema%2C%20warm%20amber%20and%20deep%20crimson%20light%20beams%20across%20a%20dark%20theater%2C%20film%20grain%20and%20dust%20particles%2C%20soft%20bokeh%2C%20moody%20dramatic%20atmosphere%2C%20artistic%20painterly%20texture%2C%20no%20text&width=1920&height=1080&seq=kfilm-hero-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/65 via-foreground-950/45 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-24 pb-14">
        <div className="max-w-5xl mx-auto text-center animate-fade-up">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/10 border border-background-50/25 text-background-100 text-xs md:text-sm">
            <i className="ri-bookmark-3-line"></i>
            影迷向 · 类型梳理与合法观影参考
          </span>

          <h1 className="mt-5 font-heading font-black text-background-50 text-3xl md:text-5xl lg:text-6xl leading-tight">
            韩国伦理电影在线观看
            <span className="block mt-2 text-2xl md:text-4xl lg:text-5xl text-accent-300">
              免费入口指南
            </span>
          </h1>

          <p className="mt-6 mx-auto max-w-2xl text-background-100 text-sm md:text-lg leading-relaxed">
            这里为影迷系统整理这一类型的发展脉络、代表作品与观影要点，覆盖高清中字、无删减完整版的合法观看思路，
            帮你在众多片单中快速找到心仪的那一部。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#films"
              className="w-full sm:w-auto px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-play-list-2-line"></i>
              浏览精选片单
            </a>
            <a
              href="#guide"
              className="w-full sm:w-auto px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-compass-3-line"></i>
              查看观影指南
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 max-w-4xl mx-auto">
          <dl className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4">
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="rounded-lg bg-background-50/10 border border-background-50/15 backdrop-blur-sm px-3 py-4 text-center"
              >
                <dt className="font-heading text-2xl md:text-3xl font-bold text-accent-300">
                  {stat.value}
                </dt>
                <dd className="mt-1 text-xs md:text-sm text-background-100">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}